module.exports = __webpack_public_path__ + "img/banner_truth_or_dare_small.50614e58.png";